function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24.91c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12s-12 5.373-12 12c0 6.628 5.373 12 12 12z",
  fill: "#627EEA"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.36 4.29v6.38l5.39 2.41-5.39-8.79z",
  fill: "#fff",
  fillOpacity: 0.602
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.36 4.29l-5.39 8.78 5.39-2.41V4.29z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.36 17.2v4.33l5.39-7.46-5.39 3.13z",
  fill: "#fff",
  fillOpacity: 0.602
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.36 21.53V17.2l-5.39-3.13 5.39 7.46z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.36 16.2l5.39-3.13-5.39-2.41v5.54z",
  fill: "#fff",
  fillOpacity: 0.2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.97 13.07l5.39 3.13v-5.54l-5.39 2.41z",
  fill: "#fff",
  fillOpacity: 0.602
});

function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "9d3ee0a9eafaccf5b70e4f04be72a6f4.svg";
export { SvgEth as ReactComponent };